/* Pure Wine: private class booking widget (sections/pw-class-booking.liquid). No dependencies.
   Ways in: class, date, build, gift (a class for someone else, who picks the date), redeem (a code
   holder picks a date and sends a request). "Book now, pick a date later" saves a class under a code. */
(function () {
  function money(n) {
    var r = Math.round(n * 100) / 100;
    return '$' + r.toLocaleString('en-US', { minimumFractionDigits: r % 1 ? 2 : 0, maximumFractionDigits: 2 });
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function ymd(d) { return d.getUTCFullYear() + '-' + pad(d.getUTCMonth() + 1) + '-' + pad(d.getUTCDate()); }
  function fromYmd(s) { var p = s.split('-'); return new Date(Date.UTC(+p[0], +p[1] - 1, +p[2], 12)); }
  function addDays(d, n) { return new Date(d.getTime() + n * 86400000); }
  function longDate(d) { return d.toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' }); }
  /* A booking or gift code: PW- plus five characters from an alphabet without 0, O, 1, I. */
  function makeCode() {
    var a = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789', s = 'PW-', arr = null, i;
    try { if (window.crypto && window.crypto.getRandomValues) { arr = new Uint32Array(5); window.crypto.getRandomValues(arr); } } catch (e) { arr = null; }
    for (i = 0; i < 5; i++) s += a.charAt((arr ? arr[i] : Math.floor(Math.random() * 4294967296)) % 32);
    return s;
  }
  /* The gift sheet link carries its data after the # so that nothing personal reaches the server or its logs. */
  function b64url(s) { return btoa(unescape(encodeURIComponent(s))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, ''); }

  function init(root) {
    if (!root || root.getAttribute('data-pw-ready')) return;
    var form = root.querySelector('form');
    var flow = root.querySelector('[data-pw-flow]');
    var success = root.querySelector('[data-pw-success]');
    if (success) {
      root.setAttribute('data-pw-ready', '1');
      success.focus({ preventScroll: true });
      success.scrollIntoView({ block: 'center' });
      return;
    }
    if (!form || !flow) return;
    root.setAttribute('data-pw-ready', '1');
    root.classList.add('is-js');

    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-pw-config]').textContent); } catch (e) {}
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

    var classRadios = qa('input[name="contact[Class]"]');
    var buildRadio = q('input[data-build]');
    var tierRadios = qa('[data-pw-tier]');
    var focusBoxes = qa('[data-pw-focus]');
    var addonBoxes = qa('[data-pw-addon]');
    var timeRadios = qa('[data-pw-time]');
    var whereRadios = qa('[data-pw-where]');
    var guests = q('[data-pw-guests]');
    var dateInput = q('[data-pw-date]');
    var outFocus = q('[data-pw-out="focus"]');
    var outEstimate = q('[data-pw-out="estimate"]');
    var termsBox = q('[data-pw-terms]');
    var submitBtn = q('[data-pw-submit]');
    var contactWrap = q('[data-pw-contact]');
    var addressWrap = q('[data-pw-address]');
    var addressInput = q('[data-pw-address-input]');
    var companyInput = q('[data-pw-company]');
    var occasionSelect = q('select[name="contact[Occasion]"]');
    var noticeHint = q('[data-pw-notice-hint]');
    /* Gifts, open dates, and redeeming. */
    var whenRadios = qa('[data-pw-when]');
    var whenWrap = q('[data-pw-whenwrap]');
    var dategrid = q('[data-pw-dategrid]');
    var laterNote = q('[data-pw-later-note]');
    var giftTo = q('[data-pw-gift="to"]'), giftFrom = q('[data-pw-gift="from"]'), giftMsg = q('[data-pw-gift="message"]'),
      giftEmail = q('[data-pw-gift="email"]'), giftSendOn = q('[data-pw-gift="sendon"]');
    var giftDelivery = qa('[data-pw-gift-delivery]');
    var giftEmailWrap = q('[data-pw-gift-emailwrap]'), giftSendWrap = q('[data-pw-gift-sendwrap]');
    var giftNoteEmail = q('[data-pw-gift-note="email"]'), giftNotePrint = q('[data-pw-gift-note="print"]');
    var giftPreview = q('[data-pw-gift-preview]');
    var giftInputs = qa('[data-pw-gift], [data-pw-gift-delivery]');
    var codeInput = q('[data-pw-code]');
    var redeemInputs = qa('[data-pw-redeem-field]');
    var whereWrap = q('[data-pw-wherewrap]');
    var extrasWrap = q('[data-pw-extraswrap]');
    var modesBar = q('[data-pw-modes]');
    var redeemHead = q('[data-pw-redeem-head]');
    var sumFor = q('[data-pw-sum-for]'), sumForRow = q('[data-pw-sum-for-row]');
    var sumCode = q('[data-pw-sum-code]'), sumCodeRow = q('[data-pw-sum-code-row]');
    var guestsLabel = q('[data-pw-guests-label]');
    var redeemGuestsHint = q('[data-pw-redeem-guests-hint]');
    var offsiteRedeemNote = q('[data-pw-offsite-redeem-note]');
    var hasGift = !!(panelsOf('gift') && cfg.giftPage);
    var hasRedeem = !!panelsOf('redeem');
    var giftCode = '';
    function panelsOf(k) { return q('[data-panel="' + k + '"]'); }
    function code() { if (!giftCode) giftCode = makeCode(); return giftCode; }
    var payMode = false;
    var busy = false;
    var panels = { redeem: panelsOf('redeem'), classes: panelsOf('classes'), build: panelsOf('build'), date: panelsOf('date'), gift: panelsOf('gift'), details: panelsOf('details') };
    var mode = 'class';
    var lastMode = 'class';

    /* ---------- calendar ---------- */
    /* "Now" is read in New York time in the browser, never in Liquid (pages are cached).
       ?pw_now=2026-10-01T18:30 previews any moment. */
    function nyNow() {
      try {
        var forced = new URLSearchParams(window.location.search).get('pw_now');
        var fm = forced && forced.match(/^(\d{4}-\d{2}-\d{2})(?:T(\d{1,2}):(\d{2}))?$/);
        if (fm) return { ymd: fm[1], minutes: fm[2] ? parseInt(fm[2], 10) * 60 + parseInt(fm[3], 10) : 0 };
      } catch (e) {}
      try {
        var o = {};
        new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
          .formatToParts(new Date()).forEach(function (p) { o[p.type] = p.value; });
        var key = o.year + '-' + o.month + '-' + o.day;
        if (/^\d{4}-\d{2}-\d{2}$/.test(key)) return { ymd: key, minutes: (parseInt(o.hour, 10) % 24) * 60 + parseInt(o.minute, 10) };
      } catch (e) {}
      var n = new Date();
      return { ymd: n.getFullYear() + '-' + pad(n.getMonth() + 1) + '-' + pad(n.getDate()), minutes: n.getHours() * 60 + n.getMinutes() };
    }
    /* "6:00 PM", "6pm", "6:30 pm" to minutes after midnight. */
    function parseTime(t) {
      var m = String(t || '').trim().match(/^(\d{1,2})(?::(\d{2}))?\s*([ap])\.?m\.?$/i);
      if (!m) return null;
      var h = parseInt(m[1], 10) % 12;
      if (/p/i.test(m[3])) h += 12;
      return h * 60 + (m[2] ? parseInt(m[2], 10) : 0);
    }
    var now = nyNow();
    var today = fromYmd(now.ymd);
    var leadHours = parseFloat(cfg.leadHours) || 0;
    var classMin = parseInt(cfg.classMinutes, 10) || 60;
    /* The earliest moment a class may start: now plus the notice period, as a New York wall-clock day and minute. */
    var np = now.ymd.split('-');
    var cut = new Date(Date.UTC(+np[0], +np[1] - 1, +np[2], 0, now.minutes) + leadHours * 3600000);
    var cutKey = ymd(cut);
    var cutMin = cut.getUTCHours() * 60 + cut.getUTCMinutes();
    var first = fromYmd(cutKey);
    var last = addDays(today, cfg.windowDays || 120);
    var slots = timeRadios.filter(function (r) { return r.hasAttribute('data-minutes'); })
      .map(function (r) { return { el: r, min: parseInt(r.getAttribute('data-minutes'), 10) }; });
    var flexRadios = timeRadios.filter(function (r) { return !r.hasAttribute('data-minutes'); });
    var blocked = {};
    var blockedTimes = {};
    String(cfg.blocked || '').split(/[\n,;]+/).forEach(function (line) {
      var tm = line.trim().match(/^(\d{4}-\d{2}-\d{2})\s+(\d{1,2}(?::\d{2})?\s*[ap]\.?m\.?)$/i);
      if (tm) {
        var mins = parseTime(tm[2]);
        if (mins !== null) (blockedTimes[tm[1]] = blockedTimes[tm[1]] || []).push(mins);
        return;
      }
      var m = line.trim().match(/^(\d{4}-\d{2}-\d{2})(?:\s*(?:\.\.|to)\s*(\d{4}-\d{2}-\d{2}))?$/);
      if (!m) return;
      var a = fromYmd(m[1]), b = m[2] ? fromYmd(m[2]) : a, guard = 0;
      for (var d = a; d <= b && guard < 400; d = addDays(d, 1), guard++) blocked[ymd(d)] = true;
    });
    /* A start time is off when it is inside the notice period, or when a class already booked that day would overlap it. */
    function slotOff(key, min) {
      if (key < cutKey) return true;
      if (key === cutKey && min < cutMin) return true;
      var taken = blockedTimes[key] || [];
      for (var i = 0; i < taken.length; i++) { if (Math.abs(taken[i] - min) < classMin) return true; }
      return false;
    }
    function freeSlots(key) {
      if (!slots.length) return key >= cutKey ? 1 : 0;
      return slots.filter(function (s) { return !slotOff(key, s.min); }).length;
    }
    function isOpen(d) {
      var key = ymd(d);
      if (key < cutKey || d > last) return false;
      if (!cfg.weekdays || !cfg.weekdays[d.getUTCDay()]) return false;
      if (blocked[key]) return false;
      return freeSlots(key) > 0;
    }
    dateInput.min = ymd(first);
    dateInput.max = ymd(last);
    if (giftSendOn) giftSendOn.min = now.ymd;

    var cal = q('[data-pw-cal]');
    var grid = q('[data-pw-cal-grid]');
    var label = q('[data-pw-cal-label]');
    var prev = q('[data-pw-cal-prev]');
    var next = q('[data-pw-cal-next]');
    var picked = q('[data-pw-picked]');
    var firstOpen = null;
    for (var s = first, g = 0; s <= last && g < 400; s = addDays(s, 1), g++) { if (isOpen(s)) { firstOpen = s; break; } }
    var anchor = firstOpen || first;
    var view = { y: anchor.getUTCFullYear(), m: anchor.getUTCMonth() };

    function renderCal() {
      var start = new Date(Date.UTC(view.y, view.m, 1, 12));
      label.textContent = start.toLocaleDateString('en-US', { month: 'long', year: 'numeric', timeZone: 'UTC' });
      var days = new Date(Date.UTC(view.y, view.m + 1, 0, 12)).getUTCDate();
      var html = '';
      for (var i = 0; i < start.getUTCDay(); i++) html += '<span></span>';
      for (var dnum = 1; dnum <= days; dnum++) {
        var d = new Date(Date.UTC(view.y, view.m, dnum, 12));
        var key = ymd(d), open = isOpen(d), sel = dateInput.value === key;
        html += '<button type="button" class="pw-cal__day' + (sel ? ' is-selected' : '') + '" data-date="' + key + '"' +
          (open ? '' : ' disabled') + ' aria-pressed="' + (sel ? 'true' : 'false') + '" aria-label="' + longDate(d) + (open ? '' : ', not available') + '">' + dnum + '</button>';
      }
      grid.innerHTML = html;
      prev.disabled = (view.y < first.getUTCFullYear()) || (view.y === first.getUTCFullYear() && view.m <= first.getUTCMonth());
      next.disabled = (view.y > last.getUTCFullYear()) || (view.y === last.getUTCFullYear() && view.m >= last.getUTCMonth());
    }
    function shift(n) {
      var d = new Date(Date.UTC(view.y, view.m + n, 1, 12));
      view = { y: d.getUTCFullYear(), m: d.getUTCMonth() };
      renderCal();
    }
    prev.addEventListener('click', function () { if (!prev.disabled) shift(-1); });
    next.addEventListener('click', function () { if (!next.disabled) shift(1); });
    grid.addEventListener('click', function (e) {
      var b = e.target.closest('[data-date]');
      if (!b || b.disabled) return;
      dateInput.value = b.getAttribute('data-date');
      renderCal();
      var again = grid.querySelector('[data-date="' + dateInput.value + '"]');
      if (again) again.focus();
      clearError('date');
      update();
    });
    var closedMsg = 'That day is not open for bookings. Pick one of the white dates, or call us.';
    var dateLabel = q('[data-pw-datefield] label');
    if (dateLabel) dateLabel.textContent = 'Or type a date';
    dateInput.addEventListener('change', function () {
      if (dateInput.value && isOpen(fromYmd(dateInput.value))) {
        var d = fromYmd(dateInput.value);
        view = { y: d.getUTCFullYear(), m: d.getUTCMonth() };
        clearError('date');
      }
      renderCal();
      update();
    });
    dateInput.addEventListener('blur', function () {
      if (dateInput.value && !isOpen(fromYmd(dateInput.value))) {
        dateInput.value = '';
        renderCal();
        update();
        showError('date', closedMsg, true);
      }
    });
    cal.hidden = false;
    renderCal();

    /* ---------- modes and panels ---------- */
    /* "Later" is the chip "Book now, pick a date later": no date, the class is saved under a code. */
    function isLater() {
      if (mode === 'gift' || mode === 'redeem') return false;
      return whenRadios.some(function (r) { return r.checked && r.getAttribute('data-pw-when') === 'later'; });
    }
    function noDate() { return mode === 'gift' || isLater(); }
    function setWhen(which) {
      whenRadios.forEach(function (r) { r.checked = r.getAttribute('data-pw-when') === which; });
    }
    function renumber() {
      var order;
      if (mode === 'redeem') order = ['redeem', 'date', 'details'];
      else if (mode === 'gift') order = ['classes', 'build', 'gift', 'details'];
      else if (mode === 'date') order = ['date', 'classes', 'build', 'details'];
      else order = ['classes', 'build', 'date', 'details'];
      var n = 0;
      order.forEach(function (k) {
        var p = panels[k];
        if (!p || p.hidden) return;
        n++;
        var el = p.querySelector('[data-pw-num]');
        if (el) el.textContent = n;
      });
    }
    function syncPanels() {
      var building = !!(buildRadio && buildRadio.checked);
      var redeem = mode === 'redeem', gift = mode === 'gift';
      if (panels.redeem) panels.redeem.hidden = !redeem;
      if (panels.build) panels.build.hidden = !building || redeem;
      if (panels.classes) panels.classes.hidden = redeem || (mode === 'build' && building);
      if (panels.gift) panels.gift.hidden = !gift;
      if (panels.date) panels.date.hidden = gift;
      tierRadios.forEach(function (r) { r.disabled = !building || redeem; });
      if (outFocus) outFocus.disabled = !building || redeem;
      classRadios.forEach(function (r) { r.required = !redeem; });
      giftInputs.forEach(function (i) { i.disabled = !gift; });
      redeemInputs.forEach(function (i) { i.disabled = !redeem; });
      if (codeInput) { codeInput.disabled = !redeem; codeInput.required = redeem; }
      if (whenWrap) whenWrap.hidden = redeem;
      if (redeem) setWhen('date');
      var later = isLater();
      if (dategrid) dategrid.hidden = later;
      if (laterNote) laterNote.hidden = !later;
      var nd = noDate();
      dateInput.required = !nd;
      dateInput.disabled = nd;
      if (nd && dateInput.value) { dateInput.value = ''; renderCal(); }
      if (whereWrap) whereWrap.hidden = gift || !cfg.offsiteEnabled;
      if (gift) whereRadios.forEach(function (r) { r.checked = r.getAttribute('data-pw-where') === 'shop'; });
      if (extrasWrap) extrasWrap.hidden = redeem;
      if (redeem) addonBoxes.forEach(function (a) { a.checked = false; });
      if (modesBar) modesBar.hidden = redeem;
      if (redeemHead) redeemHead.hidden = !redeem;
      if (guestsLabel) guestsLabel.textContent = guestsLabel.getAttribute(redeem ? 'data-text-redeem' : 'data-text');
      if (redeemGuestsHint) redeemGuestsHint.hidden = !redeem;
      flow.setAttribute('data-mode', mode);
      qa('[data-pw-modes] [data-mode]').forEach(function (b) {
        var on = b.getAttribute('data-mode') === mode;
        b.classList.toggle('is-active', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      renumber();
    }
    function setMode(m) {
      if (m === 'gift' && !hasGift) m = 'class';
      if (m === 'redeem' && !hasRedeem) m = 'class';
      if (m === 'build' && !buildRadio) m = 'class';
      mode = m;
      if (m !== 'build' && m !== 'redeem') lastMode = m;
      if (m === 'build' && buildRadio) buildRadio.checked = true;
      if (m === 'class' && buildRadio && buildRadio.checked) buildRadio.checked = false;
      syncPanels();
      update();
    }
    qa('[data-pw-modes] [data-mode]').forEach(function (b) {
      b.addEventListener('click', function () { setMode(b.getAttribute('data-mode')); });
    });
    classRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        clearError('class');
        if (r === buildRadio && mode === 'class') mode = 'build';
        syncPanels();
        update();
        if (r === buildRadio && panels.build) {
          var f = panels.build.querySelector('input:not([disabled])');
          if (f) f.focus({ preventScroll: true });
          panels.build.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }
      });
    });
    var back = q('[data-pw-back]');
    if (back) back.addEventListener('click', function () {
      if (buildRadio) buildRadio.checked = false;
      if (mode === 'build') mode = lastMode;
      syncPanels();
      update();
      if (panels.classes) panels.classes.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
    whenRadios.forEach(function (r) {
      r.addEventListener('change', function () {
        clearError('date'); clearError('time');
        syncPanels();
        update();
      });
    });
    /* Redeem: entered from the text link under the ways in, from any [data-pw-redeem-start] element, from #redeem, or from ?start=redeem. */
    function startRedeem(scroll) {
      if (!hasRedeem) return;
      setMode('redeem');
      if (scroll) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      if (codeInput && !codeInput.value) codeInput.focus({ preventScroll: true });
    }
    qa('[data-pw-redeem-start]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); startRedeem(true); });
    });
    /* A link anywhere on this page to #redeem (for example in the FAQ) opens the redeem form in place. */
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href]');
      if (!a || root.contains(a)) return;
      var h = a.getAttribute('href') || '', tag = '#' + (cfg.redeemAnchor || 'redeem');
      if (h.slice(-tag.length) !== tag) return;
      var path = h.slice(0, -tag.length).split('?')[0];
      if (path && path !== window.location.pathname) return;
      e.preventDefault();
      startRedeem(true);
    });
    window.addEventListener('hashchange', function () {
      if (window.location.hash === '#' + (cfg.redeemAnchor || 'redeem')) startRedeem(true);
    });
    var redeemBack = q('[data-pw-redeem-back]');
    if (redeemBack) redeemBack.addEventListener('click', function () {
      setMode(lastMode);
      if (modesBar) modesBar.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    if (codeInput) codeInput.addEventListener('input', function () { clearError('code'); update(); });

    focusBoxes.forEach(function (c) {
      c.addEventListener('change', function () {
        var on = focusBoxes.filter(function (x) { return x.checked; });
        var full = on.length >= (cfg.maxFocus || 2);
        focusBoxes.forEach(function (x) { x.disabled = full && !x.checked; });
        update();
      });
    });

    /* ---------- guests ---------- */
    function clampGuests() {
      var v = parseInt(guests.value, 10);
      if (isNaN(v)) v = cfg.minGuests;
      v = Math.max(cfg.minGuests, Math.min(cfg.maxGuests, v));
      guests.value = v;
      return v;
    }
    qa('[data-pw-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = parseInt(guests.value, 10);
        if (isNaN(v)) v = cfg.minGuests;
        guests.value = v + parseInt(b.getAttribute('data-pw-step'), 10);
        clampGuests();
        update();
      });
    });
    guests.addEventListener('change', function () { clampGuests(); update(); });
    guests.addEventListener('input', update);

    /* ---------- errors ---------- */
    function showError(key, msg, stay) {
      var el = q('[data-pw-error="' + key + '"]');
      if (!el) return;
      if (!el.getAttribute('data-default')) el.setAttribute('data-default', el.textContent);
      el.textContent = msg || el.getAttribute('data-default');
      el.hidden = false;
      var p = el.closest('[data-panel]');
      if (p && !stay) p.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function clearError(key) {
      var el = q('[data-pw-error="' + key + '"]');
      if (el) el.hidden = true;
    }

    /* ---------- summary and estimate ---------- */
    var sumClass = q('[data-pw-sum-class]'), sumDate = q('[data-pw-sum-date]'), sumGuests = q('[data-pw-sum-guests]'),
      sumWhere = q('[data-pw-sum-where]'), sumExtras = q('[data-pw-sum-extras]'), sumExtrasRow = q('[data-pw-sum-extras-row]'),
      sumTotal = q('[data-pw-sum-total]'), sumTotalRow = q('[data-pw-sum-total-row]'), sumMath = q('[data-pw-sum-math]'),
      sumTotalLabel = q('[data-pw-sum-total-label]'), offNote = q('[data-pw-offsite-note]');

    function chosenClass() { return classRadios.filter(function (r) { return r.checked; })[0]; }
    function giftByEmail() {
      var d = giftDelivery.filter(function (r) { return r.checked; })[0];
      return !d || d.getAttribute('data-pw-gift-delivery') === 'email';
    }

    function update() {
      var chosen = chosenClass();
      var building = !!(chosen && chosen === buildRadio);
      var tier = tierRadios.filter(function (r) { return r.checked; })[0];
      var focus = focusBoxes.filter(function (x) { return x.checked; }).map(function (x) { return x.value; });
      var redeem = mode === 'redeem', gift = mode === 'gift', later = isLater(), nd = gift || later;
      var name = 'Not chosen yet', price = 0, minG = cfg.minGuests;
      if (chosen) {
        name = chosen.value;
        minG = parseInt(chosen.getAttribute('data-min'), 10) || cfg.minGuests;
        if (building) {
          price = tier ? parseFloat(tier.getAttribute('data-price')) || 0 : 0;
          name = 'Build your own' + (tier ? ': ' + tier.value : '') + (focus.length ? ' (' + focus.join(', ') + ')' : '');
        } else {
          price = parseFloat(chosen.getAttribute('data-price')) || 0;
        }
      }
      if (outFocus) outFocus.value = focus.join(', ');
      sumClass.textContent = redeem ? (cfg.redeemClassLabel || 'The one on your code') : name;

      var dayKey = !nd && dateInput.value && isOpen(fromYmd(dateInput.value)) ? dateInput.value : '';
      var crossed = 0;
      slots.forEach(function (s) {
        var off = nd || (!!dayKey && slotOff(dayKey, s.min));
        s.el.disabled = off;
        s.el.required = !nd;
        if (!nd && dayKey && slotOff(dayKey, s.min)) crossed++;
        if (off && s.el.checked) s.el.checked = false;
      });
      flexRadios.forEach(function (r) { r.disabled = nd; r.required = !nd; if (nd) r.checked = false; });
      if (noticeHint) noticeHint.hidden = !crossed;
      var time = timeRadios.filter(function (r) { return r.checked; })[0];
      if (time) clearError('time');
      if (gift) {
        sumDate.textContent = cfg.giftDateLabel || 'They pick the date';
        picked.hidden = true;
      } else if (later) {
        sumDate.textContent = cfg.laterDateLabel || 'You pick it later';
        picked.hidden = true;
      } else if (dateInput.value && isOpen(fromYmd(dateInput.value))) {
        var txt = longDate(fromYmd(dateInput.value)) + (time ? ', ' + time.value : '');
        sumDate.textContent = txt;
        picked.textContent = txt;
        picked.hidden = false;
      } else {
        sumDate.textContent = 'Not chosen yet';
        picked.hidden = true;
      }

      var gv = parseInt(guests.value, 10);
      if (isNaN(gv)) gv = cfg.minGuests;
      sumGuests.textContent = gv;
      var where = whereRadios.filter(function (r) { return r.checked; })[0];
      var offsite = !gift && !!(where && where.getAttribute('data-pw-where') === 'offsite');
      if (where) sumWhere.textContent = where.value;
      if (offNote) offNote.hidden = !offsite;
      if (offsiteRedeemNote) offsiteRedeemNote.hidden = !(offsite && redeem);
      if (addressWrap) { addressWrap.hidden = !offsite; addressInput.disabled = !offsite; }

      /* Gift details and the summary row for the recipient. */
      var byEmail = giftByEmail();
      if (giftEmailWrap) giftEmailWrap.hidden = !byEmail;
      if (giftSendWrap) giftSendWrap.hidden = !byEmail;
      if (giftEmail) giftEmail.disabled = !gift || !byEmail;
      if (giftSendOn) giftSendOn.disabled = !gift || !byEmail;
      if (giftNoteEmail) giftNoteEmail.hidden = !gift || !byEmail;
      if (giftNotePrint) giftNotePrint.hidden = !gift || byEmail;
      if (sumForRow) sumForRow.hidden = !gift;
      if (sumFor && gift) sumFor.textContent = (giftTo && giftTo.value.trim()) || 'Not filled in yet';
      if (sumCodeRow) sumCodeRow.hidden = !redeem;
      if (sumCode && redeem) sumCode.textContent = (codeInput && codeInput.value.trim().toUpperCase()) || 'Not filled in yet';

      /* Pay online when the chosen class (or build-your-own level) has a product variant behind it. Redeeming is always a request. */
      var classVariant = '';
      if (chosen && !redeem) classVariant = building ? (tier ? tier.getAttribute('data-variant') : '') : chosen.getAttribute('data-variant');
      payMode = !!classVariant;
      if (contactWrap) {
        contactWrap.hidden = payMode;
        Array.prototype.forEach.call(contactWrap.querySelectorAll('input'), function (i) { i.disabled = payMode; });
      }
      if (submitBtn) {
        submitBtn.type = payMode ? 'button' : 'submit';
        if (!busy) submitBtn.textContent = submitBtn.getAttribute(payMode ? (gift && submitBtn.getAttribute('data-label-gift') ? 'data-label-gift' : 'data-label-pay') : 'data-label-request');
      }
      var noteKey = payMode ? (gift ? 'gift' : (later ? 'later' : 'pay')) : (redeem ? 'redeem' : 'request');
      if (!q('[data-pw-note="' + noteKey + '"]')) noteKey = payMode ? 'pay' : 'request';
      qa('[data-pw-note]').forEach(function (nt) { nt.hidden = nt.getAttribute('data-pw-note') !== noteKey; });
      if (sumTotalLabel) sumTotalLabel.textContent = payMode ? (gift ? 'Gift total' : 'Class total') : 'Estimate';

      var perPerson = 0, flat = 0, extras = [], quoted = false;
      addonBoxes.forEach(function (a) {
        if (!a.checked) return;
        var p = parseFloat(a.getAttribute('data-price')) || 0;
        extras.push(a.getAttribute('data-title'));
        if (!p) { quoted = true; return; }
        if (a.getAttribute('data-unit') === 'flat') flat += p; else perPerson += p;
      });
      if (offsite && !redeem) flat += parseFloat(where.getAttribute('data-price')) || parseFloat(cfg.offsiteFee) || 0;
      sumExtrasRow.hidden = !extras.length;
      sumExtras.textContent = extras.join(', ');

      if (chosen && price > 0 && !redeem) {
        var billable = Math.max(gv, minG);
        var total = (price + perPerson) * billable + flat;
        var math = money(price + perPerson) + ' x ' + billable + ' guests' + (flat ? ' + ' + money(flat) : '') + '.';
        if (billable > gv) math += ' This class is priced for a minimum of ' + minG + ' guests.';
        if (quoted) math += ' One extra is quoted by email.';
        sumTotal.textContent = money(total);
        sumMath.textContent = math;
        sumTotalRow.hidden = false;
        sumMath.hidden = false;
        if (outEstimate) { outEstimate.disabled = false; outEstimate.value = money(total) + ' (' + math + ')'; }
      } else {
        sumTotalRow.hidden = true;
        sumMath.hidden = redeem || !chosen;
        sumMath.textContent = chosen && !redeem ? 'We will quote this one by email.' : '';
        if (outEstimate) { outEstimate.disabled = true; outEstimate.value = ''; }
      }
    }

    [].concat(tierRadios, addonBoxes, timeRadios, whereRadios, giftDelivery).forEach(function (el) { el.addEventListener('change', update); });
    [giftTo, giftFrom, giftMsg, giftEmail].forEach(function (el) { if (el) el.addEventListener('input', function () { clearError('gift'); update(); }); });
    if (termsBox) termsBox.addEventListener('change', function () { clearError('terms'); });
    if (addressInput) addressInput.addEventListener('input', function () { clearError('address'); });

    function validate() {
      clampGuests();
      var redeem = mode === 'redeem', gift = mode === 'gift', nd = gift || isLater();
      if (redeem) {
        if (!codeInput || !codeInput.value.trim()) { showError('code'); if (codeInput) codeInput.focus({ preventScroll: true }); return false; }
      } else if (!classRadios.some(function (r) { return r.checked; })) { showError('class'); return false; }
      if (!nd) {
        if (!dateInput.value) { showError('date'); return false; }
        if (!isOpen(fromYmd(dateInput.value))) { showError('date', closedMsg); return false; }
        if (timeRadios.length && !timeRadios.some(function (r) { return r.checked; })) { showError('time'); return false; }
      }
      if (gift) {
        if (!giftTo.value.trim()) { showError('gift', 'Tell us who the gift is for.'); giftTo.focus({ preventScroll: true }); return false; }
        if (!giftFrom.value.trim()) { showError('gift', 'Add your name, so they know who it is from.'); giftFrom.focus({ preventScroll: true }); return false; }
        if (giftByEmail() && !(giftEmail.value.trim() && giftEmail.checkValidity())) { showError('gift', 'Add their email address, or choose to give it yourself.'); giftEmail.focus({ preventScroll: true }); return false; }
        if (giftSendOn && giftSendOn.value && giftSendOn.value < now.ymd) { showError('gift', 'The send-on day cannot be in the past.'); giftSendOn.focus({ preventScroll: true }); return false; }
      }
      if (addressInput && !addressInput.disabled && !addressInput.value.trim()) { showError('address'); return false; }
      if (termsBox && !termsBox.checked) { showError('terms', null, true); return false; }
      return true;
    }

    /* The gift sheet data: what the printed sheet and the gift email need, nothing more. */
    function giftData() {
      var chosen = chosenClass();
      var building = chosen === buildRadio;
      var tier = tierRadios.filter(function (r) { return r.checked; })[0];
      var focus = focusBoxes.filter(function (x) { return x.checked; }).map(function (x) { return x.value; });
      var cls = chosen ? (building ? 'Build your own' + (tier ? ': ' + tier.value : '') : chosen.value) : '';
      var gv = clampGuests();
      var minG = chosen ? (parseInt(chosen.getAttribute('data-min'), 10) || cfg.minGuests) : cfg.minGuests;
      var d = { v: 1, to: giftTo.value.trim().slice(0, 80), from: giftFrom.value.trim().slice(0, 80), cls: cls, g: Math.max(gv, minG), code: code() };
      var msg = giftMsg ? giftMsg.value.trim().slice(0, 300) : '';
      if (msg) d.msg = msg;
      if (building && focus.length) d.f = focus.join(', ');
      var x = addonBoxes.filter(function (a) { return a.checked; }).map(function (a) { return a.getAttribute('data-title'); });
      if (x.length) d.x = x;
      return d;
    }
    function giftLink(d) { return cfg.giftPage + '#g=' + b64url(JSON.stringify(d)); }
    if (giftPreview) giftPreview.addEventListener('click', function () {
      var chosen = chosenClass();
      if (!chosen) { showError('class'); return; }
      if (!giftTo.value.trim() || !giftFrom.value.trim()) { showError('gift', 'Fill in the two names first, then preview the sheet.'); return; }
      clearError('gift');
      update();
      window.open(giftLink(giftData()), '_blank', 'noopener');
    });

    /* Pay online: class variant x guests, extras, and the details as line item properties, then checkout. */
    function bookAndPay() {
      if (busy) return;
      clearError('cart');
      if (!validate()) return;
      update();
      var chosen = chosenClass();
      var building = chosen === buildRadio;
      var tier = tierRadios.filter(function (r) { return r.checked; })[0];
      var variant = building ? tier.getAttribute('data-variant') : chosen.getAttribute('data-variant');
      var gv = clampGuests();
      var minG = parseInt(chosen.getAttribute('data-min'), 10) || cfg.minGuests;
      var time = timeRadios.filter(function (r) { return r.checked; })[0];
      var where = whereRadios.filter(function (r) { return r.checked; })[0];
      var gift = mode === 'gift', later = isLater();
      var offsite = !gift && !!(where && where.getAttribute('data-pw-where') === 'offsite');
      var occasion = q('select[name="contact[Occasion]"]');
      var notes = q('textarea[name="contact[body]"]');
      var focus = focusBoxes.filter(function (x) { return x.checked; }).map(function (x) { return x.value; });

      var props = {}, forLabel, gd = null, dateTxt = '';
      if (gift) {
        gd = giftData();
        props['Date'] = cfg.giftDateProperty || 'Chosen by the recipient';
        props['Gift'] = 'Yes';
        props['Gift code'] = gd.code;
        props['For'] = gd.to;
        props['From'] = gd.from;
        if (gd.msg) props['Message'] = gd.msg;
        var deliv = giftDelivery.filter(function (r) { return r.checked; })[0];
        props['Delivery'] = deliv ? deliv.value : 'Email it for me';
        if (giftByEmail()) {
          props['Recipient email'] = giftEmail.value.trim();
          props['Send on'] = giftSendOn && giftSendOn.value ? longDate(fromYmd(giftSendOn.value)) : 'As soon as possible';
          props['_Send on date'] = giftSendOn && giftSendOn.value ? giftSendOn.value : now.ymd;
        }
        if (where) props['Where'] = where.value;
        props['_Gift sheet link'] = giftLink(gd);
        forLabel = 'Gift for ' + gd.to + ' (' + gd.code + ')';
      } else if (later) {
        props['Date'] = cfg.laterDateProperty || 'To be scheduled';
        props['Booking code'] = code();
        if (where) props['Where'] = where.value;
        if (offsite && addressInput) props['Address'] = addressInput.value.trim();
        if (offsite && where.getAttribute('data-order-note')) props['Glassware'] = where.getAttribute('data-order-note');
        forLabel = 'Private class, date to be scheduled (' + code() + ')';
      } else {
        dateTxt = longDate(fromYmd(dateInput.value));
        props['Date'] = dateTxt;
        if (time) props['Start time'] = time.value;
        if (where) props['Where'] = where.value;
        if (offsite && addressInput) props['Address'] = addressInput.value.trim();
        if (offsite && where.getAttribute('data-order-note')) props['Glassware'] = where.getAttribute('data-order-note');
        forLabel = 'Private class on ' + dateTxt;
      }
      if (gv < minG) props['Guests attending'] = String(gv);
      if (building && focus.length) props['Focus'] = focus.join(', ');
      if (companyInput && companyInput.value.trim()) props['Company'] = companyInput.value.trim().slice(0, 120);
      if (occasion && occasion.value) props['Occasion'] = occasion.value;
      if (notes && notes.value.trim()) props['Notes'] = notes.value.trim().slice(0, 500);
      if (termsBox) props['Agreed to class terms'] = 'Yes';

      var items = [{ id: parseInt(variant, 10), quantity: Math.max(gv, minG), properties: props }];
      var byRequest = [];
      addonBoxes.forEach(function (a) {
        if (!a.checked) return;
        var av = a.getAttribute('data-variant');
        if (!av) { byRequest.push(a.getAttribute('data-title')); return; }
        items.push({ id: parseInt(av, 10), quantity: a.getAttribute('data-unit') === 'flat' ? 1 : gv, properties: { 'For': forLabel } });
      });
      if (offsite) {
        var ov = where.getAttribute('data-variant');
        if (ov) items.push({ id: parseInt(ov, 10), quantity: 1, properties: { 'For': forLabel } });
        else byRequest.push(where.value);
      }
      if (byRequest.length) props['Also requested, priced by email'] = byRequest.join(', ');

      busy = true;
      submitBtn.disabled = true;
      submitBtn.textContent = 'One moment';
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      }).then(function () {
        window.location.href = rootUrl + 'checkout';
      }).catch(function () {
        busy = false;
        submitBtn.disabled = false;
        showError('cart', null, true);
        update();
      });
    }

    if (submitBtn) submitBtn.addEventListener('click', function (e) {
      if (!payMode) return;
      e.preventDefault();
      bookAndPay();
    });

    /* Capture phase, so that in pay mode nothing else (including Shopify's contact form protection) sees a submit. */
    form.addEventListener('submit', function (e) {
      if (payMode) {
        e.preventDefault();
        e.stopImmediatePropagation();
        bookAndPay();
        return;
      }
      if (!validate()) { e.preventDefault(); e.stopImmediatePropagation(); return; }
      update();
    }, true);

    /* ---------- occasion: set by the company panel's button, or by ?occasion=Team event ---------- */
    function setOccasion(name) {
      if (!occasionSelect || !name) return false;
      var wantO = String(name).toLowerCase().trim(), hit = false;
      Array.prototype.forEach.call(occasionSelect.options, function (o) {
        if (!hit && o.value.toLowerCase() === wantO) { occasionSelect.value = o.value; hit = true; }
      });
      return hit;
    }
    qa('[data-pw-company-start]').forEach(function (b) {
      b.addEventListener('click', function () {
        setOccasion(b.getAttribute('data-occasion'));
        /* The link's own #anchor does the scrolling; the company field is ready when they reach the details. */
      });
    });

    /* ---------- deep links: ?class=Title, ?start=date|build|gift|redeem, ?occasion=Name, ?code=PW-XXXXX, #redeem ---------- */
    var wantRedeem = false;
    try {
      var params = new URLSearchParams(window.location.search);
      var want = (params.get('class') || '').toLowerCase();
      if (want) classRadios.forEach(function (r) { if (r.value.toLowerCase() === want) r.checked = true; });
      var startMode = params.get('start');
      if (startMode === 'date' || (startMode === 'build' && buildRadio) || (startMode === 'gift' && hasGift)) mode = startMode;
      if (mode === 'date') lastMode = 'date';
      if (mode === 'build' && buildRadio) buildRadio.checked = true;
      setOccasion(params.get('occasion'));
      var codeParam = (params.get('code') || '').trim();
      if (codeParam && codeInput) { codeInput.value = codeParam.toUpperCase().slice(0, 24); wantRedeem = true; }
      if (startMode === 'redeem' || window.location.hash === '#' + (cfg.redeemAnchor || 'redeem')) wantRedeem = true;
    } catch (e) {}

    syncPanels();
    update();
    if (wantRedeem && hasRedeem) startRedeem(false);
  }

  function boot() { Array.prototype.forEach.call(document.querySelectorAll('[data-pw-book]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-pw-book]');
    if (r) init(r);
  });
})();
